// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vts-dropdown{display:inline-block;position:relative}.vts-dropdown__content{position:absolute;z-index:5;min-inline-size:100%}.vts-dropdown__content--top{inset-block-start:0;transform:translateY(-100%)}", ""]);
// Exports
module.exports = exports;
